// Masonry Services Images
import stoneMasonryInstallation from "@/assets/services/stone-masonry-installation-franklin-lakes-nj.webp";
import stoneMasonryRepair from "@/assets/services/stone-masonry-repair-nutley-nj.webp";
import retainingWallInstallation from "@/assets/services/retaining-wall-installation-wayne-nj.webp";
import retainingWallRepair from "@/assets/services/retaining-wall-repair-franklin-lakes-nj.webp";
import stoneVeneerInstallation from "@/assets/services/stone-veneer-installation-west-caldwell-nj.webp";
import masonryStepsInstallation from "@/assets/services/masonry-steps-installation-new-milford-nj-2.webp";
import masonryStepsRepair from "@/assets/services/masonry-steps-repair-caldwell-nj.webp";
import firePitInstallation from "@/assets/fire-pit-installation-kinnelon-nj-2.webp";
import fireplaceInstallation from "@/assets/fireplace-installation-wayne-passaic-county-nj.webp";
import outdoorKitchenInstallation from "@/assets/services/outdoor-kitchen-installation-montclair-nj.webp";
import customMasonry from "@/assets/services/custom-masonry-nutley-essex-county-new-jersey.webp";
import brickWork from "@/assets/services/brick-work-nutley-nj.webp";
import blockWork from "@/assets/services/block-work-construction-totowa-nj.webp";
import commercialMasonry from "@/assets/services/commercial-masonry-dover-morris-county-nj.webp";

// Paving Services Images
import paverPatioInstallation from "@/assets/services/paver-patio-installation-westwood-nj.webp";
import paverPatioRepair from "@/assets/services/paver-patio-repair-paterson-passaic-county-new-jersey.webp";
import paverWalkwayInstallation from "@/assets/services/paver-walkway-installation-montville-township-nj.webp";
import concreteDrivewayInstallation from "@/assets/services/concrete-driveway-installation-pompton-lakes-nj.webp";
import concreteSidewalkInstallation from "@/assets/services/concrete-sidewalk-installation-nutley-essex-county-new-jersey-3.webp";

// Concrete Services Images
import stampedConcreteInstallation from "@/assets/services/stamped-concrete-installation-west-milford-nj.webp";

import concreteFootings from "@/assets/services/concrete-footings-hudson-street-passaic-nj.webp";
import concreteFoundationRepair from "@/assets/concrete-foundation-repair-woodland-park-nj.webp";
import concreteFoundations from "@/assets/services/concrete-foundations-lincoln-park-nj.webp";
import concreteRepairCard from "@/assets/concrete-repairs-totowa-nj.webp";
import concretePatioInstallation from "@/assets/concrete-patio-finished-slab-result-totowa-nj.webp";

// Waterproofing Services Images
import basementWaterproofing from "@/assets/services/basement-waterproofing-carlstadt-nj.webp";
import patioWaterproofing from "@/assets/services/patio-waterproofing-palisades-park-nj-3.webp";

export interface ServiceItem {
  image?: string;
  title: string;
  description: string;
  link: string;
  alt: string;
}

export const masonryServices: ServiceItem[] = [
  {
    image: stoneMasonryInstallation,
    title: "Stone Masonry Installation",
    description: "Custom stone work for retaining walls, facades, and landscape features. Built with proper drainage and lasting craftsmanship.",
    link: "/masonry-services/stone-masonry",
    alt: "Stone masonry installation on a retaining wall in Franklin Lakes, Bergen County, New Jersey with grey and brown stones",
  },
  {
    image: stoneMasonryRepair,
    title: "Stone Masonry Repair",
    description: "Restore cracked, crumbling, or settling stonework. We match existing materials and fix the root cause.",
    link: "/masonry-services/stone-masonry-repair",
    alt: "Stone masonry repair on a retaining wall and steps leading to a house in Nutley, Essex County, New Jersey",
  },
  {
    image: retainingWallInstallation,
    title: "Retaining Wall Installation",
    description: "Structural retaining walls built with drainage-first engineering. Level your yard or prevent erosion with walls that hold.",
    link: "/masonry-services/retaining-walls",
    alt: "Finished retaining wall and landscape grading along a paved walkway in Wayne, Passaic County, New Jersey",
  },
  {
    image: retainingWallRepair,
    title: "Retaining Wall Repair",
    description: "Fix leaning, bulging, or cracked retaining walls. We address drainage issues and rebuild for lasting stability.",
    link: "/masonry-services/retaining-wall-repair",
    alt: "Stone retaining wall repair in Franklin Lakes, Bergen County, New Jersey with pavers",
  },
  {
    image: stoneVeneerInstallation,
    title: "Stone Veneer Installation",
    description: "Transform the look of your home with natural or manufactured stone veneer. Applied properly for lasting beauty.",
    link: "/masonry-services/stone-veneer",
    alt: "Mason working on stone veneer installation around a front door in West Caldwell, Essex County, New Jersey",
  },
  {
    image: masonryStepsInstallation,
    title: "Masonry Steps & Stoops Installation",
    description: "Front steps, side steps, porch stoops, built with proper footings and drainage. No more wobbly steps.",
    link: "/masonry-services/steps-stoops",
    alt: "Masonry steps installation and paver walkway leading to a house entrance in New Milford, Bergen County, New Jersey",
  },
  {
    image: masonryStepsRepair,
    title: "Masonry Steps & Stoops Repair",
    description: "Repair cracked treads, loose risers, and settling steps. We fix the structure, not just the surface.",
    link: "/masonry-services/steps-stoops-repair",
    alt: "Newly repaired masonry steps with brick and bluestone treads leading to a red door in Caldwell, NJ",
  },
  {
    image: firePitInstallation,
    title: "Fire Pit Installation",
    description: "Custom fire pits that become the gathering spot in your backyard. Built with proper ventilation and fire-safe materials.",
    link: "/masonry-services/fire-pits",
    alt: "Outdoor fire pit with flickering flames and gray sectional seating at Gravel Hill Road, Kinnelon, Morris County, New Jersey, 07405",
  },
  {
    image: fireplaceInstallation,
    title: "Fireplace Installation",
    description: "Statement outdoor fireplaces that extend your living space into the cooler months. Custom designs to match your home.",
    link: "/masonry-services/fireplace-installation",
    alt: "Outdoor fireplace and chimney installation with stone veneer in Wayne, Passaic County, NJ",
  },
  {
    image: outdoorKitchenInstallation,
    title: "Outdoor Kitchen Installation",
    description: "Complete outdoor cooking areas with countertops, grills, and storage. Built to withstand New Jersey's weather.",
    link: "/masonry-services/outdoor-kitchens",
    alt: "Custom outdoor kitchen installation with granite countertops and built-in grill by a pool in Montclair, NJ",
  },
  {
    image: customMasonry,
    title: "Custom Masonry",
    description: "Unique masonry projects tailored to your vision. Columns, planters, mailbox surrounds, outdoor bars, and more.",
    link: "/masonry-services/custom-masonry",
    alt: "Custom masonry outdoor bar with gray stone pavers in Nutley, Essex County, New Jersey",
  },
  {
    image: brickWork,
    title: "Brick Work",
    description: "Traditional brick construction and repair. Walls, facades, steps, and decorative features built to last.",
    link: "/masonry-services/brick-work",
    alt: "A mason laying bricks to build a wall, carefully spreading mortar with a trowel on a scaffold in Nutley, NJ",
  },
  {
    image: blockWork,
    title: "Block Work",
    description: "CMU block construction for foundations, retaining walls, and structural applications. Strong and cost-effective.",
    link: "/masonry-services/block-work",
    alt: "Block work construction in Totowa, Passaic County, New Jersey",
  },
  {
    image: commercialMasonry,
    title: "Commercial Masonry & Concrete",
    description: "CMU walls, concrete slabs, block foundations, and structural repairs for warehouses, retail centers, schools, and municipal buildings.",
    link: "/masonry-services/commercial-masonry",
    alt: "Commercial masonry construction site at a building in Dover, Morris County, NJ, by Masonry Pro Construction",
  },
];

export const pavingServices: ServiceItem[] = [
  {
    image: paverPatioInstallation,
    title: "Paver Patio Installation",
    description: "Custom paver installations with proper base preparation and drainage. Patios that stay level for decades.",
    link: "/paving-services/paver-patios",
    alt: "Newly installed paver patio next to a gray house in Westwood, Bergen County, New Jersey",
  },
  {
    image: paverPatioRepair,
    title: "Paver Patio Repair",
    description: "Fix sinking, shifting, or weed-filled paver patios. We re-level, re-sand, and restore your outdoor space.",
    link: "/paving-services/paver-patio-repair",
    alt: "Finished paver patio with decorative rock border and garden bed, ready for use in Paterson, Passaic County, New Jersey",
  },
  {
    image: paverWalkwayInstallation,
    title: "Paver Walkway Installation",
    description: "Beautiful walkways with proper grading and drainage. Connect your spaces with paths that last.",
    link: "/paving-services/paver-walkways",
    alt: "New paver walkway installation with gazebo in a backyard in Pine Brook, Morris County, New Jersey",
  },
  {
    image: concreteDrivewayInstallation,
    title: "Paver Driveway Installation",
    description: "Custom paver driveways with deep base preparation for vehicle weight. Belgian block borders, herringbone patterns, and premium brands.",
    link: "/paving-services/paver-driveways",
    alt: "Newly installed paver driveway with dark border, leading to a white gate in Pompton Lakes, NJ",
  },
];

// Concrete Driveway Image
import concreteDrivewayLincolnPark from "@/assets/concrete-driveway-lincoln-park-nj.webp";

export const concreteServices: ServiceItem[] = [
  {
    image: concreteFoundations,
    title: "Concrete Foundations",
    description: "New foundation installation for custom homes, additions, and walkout basements. Built for North Jersey soil and weather.",
    link: "/concrete-services/foundations",
    alt: "Concrete foundation installation in Lincoln Park, Morris County, New Jersey",
  },
  {
    image: concreteDrivewayLincolnPark,
    title: "Concrete Driveway Installation",
    description: "Heavy-duty concrete driveways built for daily vehicle traffic. Proper base work, reinforcement, and control joints on every pour.",
    link: "/concrete-services/driveways",
    alt: "Pebble-finished concrete driveway leading to a modern home in Lincoln Park, Morris County, New Jersey, 07035",
  },
  {
    image: stampedConcreteInstallation,
    title: "Stamped Concrete Installation",
    description: "Decorative stamped concrete that mimics stone, brick, or tile at a fraction of the cost.",
    link: "/concrete-services/stamped-concrete",
    alt: "Stamped concrete driveway leading to a house with two garage doors in West Milford, NJ",
  },
  {
    image: concreteFoundationRepair,
    title: "Concrete Foundation Repair",
    description: "Foundation crack repair, bowing wall stabilization, slab lifting, and new pours. Built for North Jersey soil and winters.",
    link: "/concrete-services/foundation-repair",
    alt: "Concrete foundation repair in Woodland Park, Passaic County, NJ by Masonry Pro Construction",
  },
  {
    image: concreteRepairCard,
    title: "Concrete Repair",
    description: "Cracked, sunken, or spalling concrete? We diagnose what's happening underneath and repair driveways, walkways, and patios across North Jersey.",
    link: "/concrete-services/repair",
    alt: "Concrete repair work on a residential driveway in Totowa, NJ",
  },
  {
    image: concreteSidewalkInstallation,
    title: "Concrete Sidewalk Installation",
    description: "Safe, level sidewalks and walkways. ADA compliant options available for commercial properties.",
    link: "/concrete-services/sidewalks",
    alt: "Newly installed concrete sidewalk and stone retaining wall in front of a blue house in Nutley, Essex County, New Jersey",
  },
  {
    image: concretePatioInstallation,
    title: "Concrete Patio Installation",
    description: "Broom-finish concrete patios built with proper base prep and drainage for North Jersey's clay soil and freeze-thaw winters.",
    link: "/concrete-services/patios",
    alt: "Finished concrete patio slab with outdoor dining set behind a Totowa, NJ home",
  },
  {
    image: concreteFootings,
    title: "Concrete Footings",
    description: "Structural footings for decks, porches, additions, and retaining walls. Built to code with proper reinforcement.",
    link: "/concrete-services/footings",
    alt: "Poured concrete footings with rebar reinforcement for new construction on Hudson Street, Passaic, New Jersey",
  },
];

export const waterproofingServices: ServiceItem[] = [
  {
    image: basementWaterproofing,
    title: "Basement Waterproofing",
    description: "Exterior basement waterproofing to stop water infiltration at the source. Protect your foundation and living space.",
    link: "/waterproofing-services/basement-waterproofing",
    alt: "Basement waterproofing membrane installed on a building foundation Carlstadt, Bergen County, New Jersey",
  },
  {
    image: patioWaterproofing,
    title: "Patio Waterproofing",
    description: "Waterproofing for elevated patios, rooftop decks, and balconies. Prevent water damage to structures below.",
    link: "/waterproofing-services/patio-waterproofing",
    alt: "Newly installed patio pavers and garden bed with steps leading to a deck, featuring patio waterproofing in Palisades Park, Bergen County, New Jersey, 07650",
  },
];

// Curated sibling grid for masonry pages only. Keys are page paths; values are
// ordered lists of sibling links (cluster union, deduped, capped at 6).
export const masonrySiblingMap: Record<string, string[]> = {
  "/masonry-services/retaining-walls": [
    "/masonry-services/retaining-wall-repair",
    "/masonry-services/block-work",
    "/masonry-services/stone-masonry",
    "/masonry-services/stone-masonry-repair",
  ],
  "/masonry-services/retaining-wall-repair": [
    "/masonry-services/retaining-walls",
    "/masonry-services/block-work",
    "/masonry-services/stone-masonry",
    "/masonry-services/stone-masonry-repair",
  ],
  "/masonry-services/block-work": [
    "/masonry-services/retaining-walls",
    "/masonry-services/retaining-wall-repair",
    "/masonry-services/stone-masonry",
    "/masonry-services/stone-masonry-repair",
    "/masonry-services/brick-work",
    "/masonry-services/commercial-masonry",
  ],
  "/masonry-services/stone-masonry": [
    "/masonry-services/retaining-walls",
    "/masonry-services/retaining-wall-repair",
    "/masonry-services/block-work",
    "/masonry-services/stone-masonry-repair",
    "/masonry-services/steps-stoops",
    "/masonry-services/steps-stoops-repair",
  ],
  "/masonry-services/stone-masonry-repair": [
    "/masonry-services/retaining-walls",
    "/masonry-services/retaining-wall-repair",
    "/masonry-services/block-work",
    "/masonry-services/stone-masonry",
  ],
  "/masonry-services/steps-stoops": [
    "/masonry-services/steps-stoops-repair",
    "/masonry-services/brick-work",
    "/masonry-services/stone-masonry",
  ],
  "/masonry-services/steps-stoops-repair": [
    "/masonry-services/steps-stoops",
    "/masonry-services/brick-work",
    "/masonry-services/stone-masonry",
  ],
  "/masonry-services/brick-work": [
    "/masonry-services/steps-stoops",
    "/masonry-services/steps-stoops-repair",
    "/masonry-services/stone-masonry",
    "/masonry-services/block-work",
    "/masonry-services/commercial-masonry",
    "/masonry-services/stone-veneer",
  ],
  "/masonry-services/outdoor-kitchens": [
    "/masonry-services/fire-pits",
    "/masonry-services/fireplace-installation",
    "/masonry-services/custom-masonry",
    "/masonry-services/stone-veneer",
  ],
  "/masonry-services/fire-pits": [
    "/masonry-services/outdoor-kitchens",
    "/masonry-services/fireplace-installation",
    "/masonry-services/custom-masonry",
    "/masonry-services/stone-veneer",
  ],
  "/masonry-services/fireplace-installation": [
    "/masonry-services/outdoor-kitchens",
    "/masonry-services/fire-pits",
    "/masonry-services/custom-masonry",
    "/masonry-services/stone-veneer",
  ],
  "/masonry-services/custom-masonry": [
    "/masonry-services/outdoor-kitchens",
    "/masonry-services/fire-pits",
    "/masonry-services/fireplace-installation",
    "/masonry-services/stone-veneer",
  ],
  "/masonry-services/stone-veneer": [
    "/masonry-services/outdoor-kitchens",
    "/masonry-services/fire-pits",
    "/masonry-services/fireplace-installation",
    "/masonry-services/custom-masonry",
    "/masonry-services/brick-work",
    "/masonry-services/commercial-masonry",
  ],
  "/masonry-services/commercial-masonry": [
    "/masonry-services/brick-work",
    "/masonry-services/block-work",
    "/masonry-services/stone-veneer",
  ],
};
